import lazy from 'utils/lazy';

export const Product = lazy(() => import('./Product'));
